export const APPROVED = 'approved';
export const COMPLETE = 'complete';
export const CURRENT = 'current';
export const INCOMPLETE = 'incomplete';
export const NOT_APPROVED = 'notApproved';
export const PAST_DUE = 'pastDue';
export const PENDING_APPROVAL = 'pendingApproval';
export const INFO_REQUIRED = 'infoRequired';
export const CANCELED = 'canceled';

export const OrderStatus = {
    APPLICATION_STARTED: 'application_started',
    APPROVED: 'approved',
    AWAITING_PAYMENT: 'awaiting_payment',
    CANCELED: 'canceled',
    CHARGED_OFF: 'charged_off',
    CLAIMED: 'claimed',
    COMPLETE: 'complete',
    CONDITIONAL_APPROVAL: 'conditional_approval',
    CONDITIONAL_REPAYMENT: 'conditional_repayment',
    DEFAULT: 'default',
    DENIED: 'denied',
    DISBURSED: 'disbursed',
    LATE: 'late',
    PENDING: 'pending',
    PARTIALLY_REFUNDED: 'partially_refunded',
    REFUNDED: 'refunded',
    REPAYMENT: 'repayment',
    VERIFICATION: 'verification',
};
